/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 8:22 AM
 *
 */

import { HamburgerMenuIcon } from '@radix-ui/react-icons';
import { useAppDispatch, useAppSelector } from 'stores';
import { toggleOpen } from 'stores/slices/sideBarSlice';

import ImageAvatar from 'components/ImageAvatar';
import BreadCrumb from 'components/layout/BreadCrumb/BreadCrumb';

const Header = () => {
  const open = useAppSelector((state) => state.sidebar.open);
  const dispatch = useAppDispatch();

  return (
    <header
      className={`fixed top-0 left-0 z-30 w-full bg-white transition-all duration-200 print:hidden ${
        !open ? 'pl-24 sm:pl-0' : 'pl-[23rem] sm:pl-0'
      } `}
    >
      <div className="flex h-24 items-center justify-between px-12 sm:px-4">
        <div>
          <HamburgerMenuIcon
            fontSize={48}
            className="hidden cursor-pointer sm:flex"
            onClick={() => dispatch(toggleOpen)}
          />
          {open && (
            <div
              className="hidden sm:fixed sm:inset-0 sm:flex sm:bg-black sm:opacity-40"
              onClick={() => dispatch(toggleOpen)}
            />
          )}
        </div>

        <div className="flex items-center gap-8 sm:hidden">
          {/* <WelcomeModal images={user?.role?.id === 1 ? adminWelcomeSlides : orgAdminWelcomeSlides}>
            <div className="cursor-pointer text-gray-600 hover:text-gray-900" title="How to Use">
              <Question size={32} />
            </div>
          </WelcomeModal>*/}

          <ImageAvatar />
        </div>
      </div>
      <hr className="border-t-[1px] border-gray-200" />{' '}
      {location.pathname !== '/dashboard' && (
        <div className="flex h-12 w-full bg-white px-10 sm:px-6">
          <BreadCrumb />
        </div>
      )}
    </header>
  );
};

export default Header;
